<template>
  <form class="re-captcha-form" ref="formRef" @submit="onSubmit" :class="{'re-captcha-form--pending': state.pending}">

    <h2 class="re-captcha-form__title" v-if="title">{{ props.title }}</h2>

    <slot v-if="!state.success && !state.error"/>
    <AppButton v-if="!state.success && !state.error"
               :title="buttonLabel || defaultButtonLabel"
               :fullWidth="true"
               type="submit"
    />

    <div v-if="state.error" class="error error--message">
      <h4 class="re-captcha-form__title-2">Insturen mislukt</h4>
      <p class="re-captcha-form__text">{{ state.errorMessage }}</p>
    </div>

    <div v-if="state.success" class="success">
      <h4 class="re-captcha-form__success-message-title">Gelukt</h4>
      <p class="re-captcha-form__text">{{ props.successMessage || defaultSuccessMessage }}</p>
    </div>

  </form>
</template>

<script setup lang="ts">
import {onMounted, reactive, ref} from "vue";
import {postForm} from "~/services/custom-endpoints";
import {useRecaptcha} from "~/composables/useRecaptcha";

const defaultErrorMessage = "Oeps, er ging iets mis."
const defaultSuccessMessage = "Bedankt."
const defaultButtonLabel = "Verstuur"
const formRef = ref<HTMLFormElement>()

const props = defineProps<{
  title?: string,
  buttonLabel?: string,
  successMessage?: string,
  formId: number | string,
  type: 'form' | 'newsletter'
}>()

const state = reactive({
  success: false,
  error: false,
  errorMessage: defaultErrorMessage,
  pending: false,
  token: false
})

onMounted(async () => {
  state.token = await useRecaptcha()
})

const onSubmit = (e) => {
  e.preventDefault()
  state.pending = true
  if (state.token) {

    const formData = new FormData(formRef.value)

    postForm(props.type, props.formId, formData).then((res) => {
      state.pending = false
      state.success = !res.error.value
    }).catch((e) => {
      state.error = true
      state.pending = false
      state.errorMessage = e
    })

  } else {
    state.pending = false
    state.error = true
    state.errorMessage = defaultErrorMessage
  }
}

</script>

<style lang="postcss">
.re-captcha-form {
  &__title {
    @mixin heading-h4-wide;
  }

  &__title-2 {
    margin-bottom: 0.5rem;
    font-family: Midnight, sans-serif;
    font-size: 0.75rem;
    text-transform: uppercase;
    line-height: 0.8;
    color: var(--color-red);
  }

  &__text {
    @mixin app-body-small;
  }

  &__success-message-title {
    margin-bottom: 0.5rem;
    font-family: Midnight, sans-serif;
    font-size: 0.75rem;
    text-transform: uppercase;
    line-height: 0.8;
  }

  &--pending {
    pointer-events: none;

    > input, textarea, button {
      opacity: 0.5;
    }
  }
}
</style>
